module.exports = __webpack_public_path__ + "media/images/arrow-right-gold-482095709391a45b3c9bc8f099bb7c7b.svg";